import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class NetworkGroupHeaderService {
  // Single writable signal that can be read/written directly
  networkGroupId = signal<string | null>(null);

  // Observable for compatibility with existing RxJS code
  networkGroupId$ = toObservable(this.networkGroupId);

  constructor() {}
}
